import React from 'react';
import {Box} from '@mui/material';
import {UseFormHandleSubmit} from 'react-hook-form';
import MuiFabButtonBack from "../mui/mui_buttons/fab/extended/MuiFabButtonBack";
import MuiFabButtonSaveAs from "../mui/mui_buttons/fab/extended/MuiFabButtonSaveAs";
import MuiFabButtonSave from "../mui/mui_buttons/fab/extended/MuiFabButtonSave";
import MuiFabButtonDelete from "../mui/mui_buttons/fab/extended/MuiFabButtonDelete";

interface SaveOrBackFormProps {
    onSubmit: (data: any) => void;
    onClose: () => void;
    initialObjToEdit?: any;
    handleSubmit: UseFormHandleSubmit<any>;
    onDelete?: () => void;
    showDelete?: boolean;
    saveOnClose?: boolean;
}

const SaveOrBackForm: React.FC<SaveOrBackFormProps> = ({
                                                           onSubmit,
                                                           onClose,
                                                           initialObjToEdit,
                                                           handleSubmit,
                                                           onDelete,
                                                           showDelete = false,
                                                           saveOnClose = false
                                                       }) => {
    const handleClose = async () => {
        if (saveOnClose) {
            await handleSubmit(onSubmit)();
            onClose();
        } else {
            onClose();
        }
    };

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
                marginTop: 2,
            }}
        >
            <MuiFabButtonBack onClick={handleClose}/>
            {initialObjToEdit ? (
                <MuiFabButtonSaveAs onClick={handleSubmit(onSubmit)}/>
            ) : (
                <MuiFabButtonSave onClick={handleSubmit(onSubmit)}/>
            )}
            {showDelete && onDelete && (
                <MuiFabButtonDelete onClick={onDelete}/>
            )}
        </Box>
    );
};

export default SaveOrBackForm;